
namespace GeniuzPOS.RefundReasonReport {

    @Serenity.Decorators.registerClass()
    export class ReportRefundReasonSumBillDtGrid extends Serenity.EntityGrid<ReportRefundReasonSumBillDtRow, any> {
        protected getColumnsKey() { return ReportRefundReasonSumBillDtColumns.columnsKey; }
        protected getDialogType() { return ReportRefundReasonSumBillDtDialog; }
        protected getIdProperty() { return ReportRefundReasonSumBillDtRow.idProperty; }
        protected getInsertPermission() { return ReportRefundReasonSumBillDtRow.insertPermission; }
        protected getLocalTextPrefix() { return ReportRefundReasonSumBillDtRow.localTextPrefix; }
        protected getService() { return ReportRefundReasonSumBillDtService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons() {
            var buttons = super.getButtons();

             buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'refresh-button'), 1)
             buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)
             //buttons.push(send);


             // Add buttons import excel, pdf
             buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                 grid: this,
                 service: ReportRefundReasonSumBillService.baseUrl + '/ListExcel',
                 onViewSubmit: () => this.onViewSubmit(),
                 separator: true
             }));

            

            return buttons;
        }
    }
}